export default __webpack_public_path__ + "static/media/person_icon.ec1b7316.svg";